<template>
  <div class="class-charts">
    <!-- 分类得分情况 -->
    <div class="canvas-box" id="myPerChart"></div>
  </div>
</template>
<script>
export default {
  props: ["model", "result1"],
  data() {
    return {
      bar: "",
      data1: [],
      personalityValues: [],
      count: 0,
      back: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
    };
  },
  mounted() {
    this.renderMap();
  },
  watch: {
    model(val) {
      if (val) {
        this.renderMap();
      }
    },
  },
  methods: {
    renderMap() {
      let myBarChart = (window.cc = this.$echarts.init(
        document.getElementById("myPerChart"),
        null,
        {
          renderer: "svg",
        }
      ));
      let zhetuStyle = [
        {
          text: "稳定性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "条理性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "细致性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "思考性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "社交性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "活动性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "迅速性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "冒险性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "领导性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
        {
          text: "投注性",
          width: 30,
          height: 65,
          fill: "black",
          shadowColor: "black",
          fontWeight: "bold",
        },
      ];
      let option = {
        title: {
          text: "人格特质测评分析",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },

        grid: {
          left: "3%",
          right: "4%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          max: 10,
          min: 0,
          interval: 1,
          type: "value",
          axisLine: { show: true }, // 轴线

          axisTick: { show: false }, // 刻度
          splitLine: { show: true }, // 分隔线
        },
        yAxis: {
          axisLine: { show: true }, // 轴线
          axisTick: { show: false }, // 刻度
          splitLine: { show: true }, // 分隔线
          type: "category",
          data: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
        },
        graphic: {
          elements: [
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 69,
              style: zhetuStyle[0],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 98,
              style: zhetuStyle[1],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 125,
              style: zhetuStyle[2],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 152,
              style: zhetuStyle[3],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 182,
              style: zhetuStyle[4],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 210,
              style: zhetuStyle[5],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 236,
              style: zhetuStyle[6],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 266,
              style: zhetuStyle[7],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 293,
              style: zhetuStyle[8],
            },
            {
              type: "text",
              zlevel: 10,
              left: 305,
              top: 320,
              style: zhetuStyle[9],
            },
          ],
        },
        series: [
          {
            barWidth: "70%", //
            // showBackground: true,

            // stack: 2, //叠加属性，下载不支持
            itemStyle: {
              normal: {
                color: function (params) {
                  let colors = [
                    "#27BDB9",
                    "#A1DFDF",
                    "#27BDB9",
                    "#A1DFDF",
                    "#27BDB9",
                    "#A1DFDF",
                    "#27BDB9",
                    "#A1DFDF",
                    "#27BDB9",
                    "#A1DFDF",
                  ];
                  return colors[params.dataIndex];
                },
              },
            },
            barCategoryGap: "0%",

            label: {
              show: false,
            },
            type: "bar",
            data: this.result1,
          },

          // {
          //   itemStyle: {
          //     color: "#fff",
          //   },
          //   // stack: 1, //叠加属性，下载不支持
          //   label: {
          //     normal: {
          //       show: false,
          //       fontSize: 12,
          //       fontWeight: "bold",
          //       position: "insideRight",
          //       offset: [0, 8],
          //       textStyle: {
          //         // 数值样式
          //         fontWeight: "bold",
          //         color: "black",
          //         fontSize: 12,
          //       },
          //       formatter: function (val) {
          //         if (val.dataIndex === 0) {
          //           return `投注型`;
          //         } else if (val.dataIndex === 1) {
          //           return `领导性`;
          //         } else if (val.dataIndex === 2) {
          //           return `冒险性`;
          //         } else if (val.dataIndex === 3) {
          //           return `迅速性`;
          //         } else if (val.dataIndex === 4) {
          //           return `活动性`;
          //         } else if (val.dataIndex === 5) {
          //           return `社交性`;
          //         } else if (val.dataIndex === 6) {
          //           return `思考性`;
          //         } else if (val.dataIndex === 7) {
          //           return `细致性`;
          //         } else if (val.dataIndex === 8) {
          //           return `条理性`;
          //         } else if (val.dataIndex === 9) {
          //           return `稳定性`;
          //         }
          //       },
          //     },
          //   },
          //   type: "bar",
          //   data: this.back,
          // },
        ],
      };
      myBarChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.class-charts {
  position: relative;
  .canvas-box {
    width: 360px;
    height: 360px;
    margin: 0 0 0 120px;
    // margin: 10px auto 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/personality/personalityTraits.vue